<template>
    <v-toolbar :color="toolbarColor" dark dense elevation="1">
        <v-icon left>mdi-file-document-edit</v-icon>
        <v-toolbar-title v-if="user.isResidenceAssistant == '1'">Online Residence Application - Residence Assistant
        </v-toolbar-title>
        <v-toolbar-title v-else>Online Residence Application</v-toolbar-title>
        <v-spacer></v-spacer>
    </v-toolbar>
</template>

<script>
export default {
    name: 'online-residence-application-toolbar',
    props: {
        user: {
            required: true
        }
    },
    computed: {
        toolbarColor() {
            return '#1BC5BD';
        }
    }
}
</script>